import React from 'react';

import {formatDate, formatTime} from 'utils/datetime';

import './styles.css';

interface TimeBelowDateProps {
  date: string;
}

const TimeBelowDate = ({date}: TimeBelowDateProps) => (
  <div className="TimeBelowDate">
    <div className="TimeBelowDate__date"> {formatDate(date)}</div>
    <div className="TimeBelowDate__time"> {formatTime(date)}</div>
  </div>
);

export default TimeBelowDate;
